import React, { PropTypes } from 'react';
import AnimateOnChange from 'react-animate-on-change';
import Field from '../../common/Field/Field';
import './CodeField.less';

function isTextComplete(text, length) {
  return text && text.length === length;
}

class CodeField extends Field {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      code: props.defaultCode || ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(ev) {
    const code = ev.target.value;
    const {onChange, onSubmit, length} = this.props;

    this.setState({code});

    if (onChange) {
      onChange(code);
    }

    if (onSubmit && isTextComplete(code, length)) {
      onSubmit(code);
    }
  }

  render () {
    const {placeholder, length, autoFocus, disabled} = this.props;
    const {code, animateError} = this.state;
    const {handleChange} = this;

    return (
      <AnimateOnChange
          baseClassName="code-field"
          animationClassName="shake--active"
          animate={animateError}>
        <input type="text"
          placeholder={placeholder}
          maxLength={length}
          value={code}
          onChange={handleChange}
          autoFocus={autoFocus}
          disabled={disabled}/>
      </AnimateOnChange>
    );
  }
}

CodeField.defaultProps = {
  defaultCode: '',
  length: 4,
  placeholder: '0000'
};

CodeField.propTypes = {
  defaultCode: PropTypes.string,
  length: PropTypes.number,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default CodeField;



// WEBPACK FOOTER //
// ./src/components/common/CodeField/CodeField.js